import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Radio } from "lucide-react";

/** Genesys → Kippu screen-pop landing page.
 *  Called by the Genesys agent desktop when an outbound/inbound call is
 *  routed. Query params carry any of: kippu_lead_id, conversation_id,
 *  genesys_contact_id, phone. We resolve the matching lead server-side and
 *  redirect to /leads/{id}?src=genesys[&conversation=<id>].
 */
export default function GenesysScreenPop() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const q = Object.fromEntries(params.entries());
    api
      .get("/genesys/screen-pop", { params: q })
      .then((r) => {
        if (r.data?.redirect_path) navigate(r.data.redirect_path, { replace: true });
        else navigate("/leads", { replace: true });
      })
      .catch(() => {
        toast.error("Screen-pop lookup failed. Redirecting to Leads.");
        navigate("/leads", { replace: true });
      });
  }, [params, navigate]);

  return (
    <div className="min-h-[60vh] grid place-items-center text-sm text-slate-500" data-testid="screen-pop">
      <div className="flex items-center gap-3">
        <Radio className="w-4 h-4 text-emerald-600 animate-pulse" />
        Resolving Genesys screen-pop…
      </div>
    </div>
  );
}
